import { site } from '../../config';
import { SustainableCorner } from '../SustainableCorner';
import * as style from './ProductStickers.module.css';
import type { Sticker } from './ProductTags';
import ProductTags from './ProductTags';

export interface ProductStickersProps {
    stickers?: Sticker[];
    sustainable?: boolean;
}

export default function ProductStickers({ stickers, sustainable }: ProductStickersProps) {
    if (!stickers) return null;

    return (
        <div className={style.stickerContainer}>
            <ProductTags tags={stickers.filter((tag) => !tag.sustainability)} />
            {sustainable && (
                <div className={style.sustainableContainer}>
                    <SustainableCorner />
                    <h5>Bærekraft</h5>
                    <p>
                        Produkter med ett eller flere bærekraftselementer er merket med et grønt hjørne.{' '}
                        <a href={site.sustainabilitySymbolsUrl()}>Les mer</a>
                    </p>
                    <ProductTags tags={stickers.filter((tag) => tag.sustainability)} />
                </div>
            )}
        </div>
    );
}
